import React from 'react';

import Movable from '../../../shared/tools/movable';

import Image from './image/Image';
import ArrowLeft from '../helper/arrowLeft/ArrowLeft';
import ArrowRight from '../helper/arrowRight/ArrowRight';
import ExitButton from '../helper/exitButton/ExitButton';

import styles from './FullGallery.module.scss';
import Utils from '../../../shared/tools/Utils';


// images props should be like in below example:
// [
//   { id: 0, img: 'path_to_img', },
//   { id: 1, img: 'path_to_img', },
//   { id: 3, img: 'path_to_img', },
// ]

class FullGallery extends React.Component {
  static defaultProps = {
    selectedImage: undefined,
    images: [],
    onSelectImage: (image) => {},
    onClose: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      imageOffset: Movable.DefaultValues(),
      disableTransition: false,
      littleImagesOffset: Movable.DefaultValues(),
      littleImagesBaseOffsetX: 0,
    };

    this.movableEvents = Movable.events({
      onMove: this.onMove,
      onMoveEnd: this.onMoveEnd
    });
    this.movableLittleImagesEvents = Movable.events({
      onMove: this.onMoveLittileImages,
      onMoveEnd: this.onMoveEndLittileImages
    });
  }

  getIndexOfImage = (image) => {
    return image.id;

    // // Calculate image position
    // for (let i = 0; i < this.props.images.length; i++) {
    //   if (this.props.images[i] === image) return i;
    // }
    // return -1;
  }

  onKeyUp = (event) => {
    if (event.keyCode === 37) {  // ArrowLeft
      this.onPrev();
    } else if (event.keyCode === 39) {  // ArrowRight
      this.onNext();
    } else if (event.keyCode === 27) {
      this.onClickExitButton();
    }
  }

  onNext = () => {
    let index = this.getIndexOfImage(this.props.selectedImage);
    const images = this.props.images;
    if (!images) return;

    if (index === images.length - 1) {
      index = -1;
    }
    index++;

    this.props.onSelectImage(images[index]);
    this.setState({
      littleImagesBaseOffsetX: 0,
    });
  };

  onPrev = () => {
    let index = this.getIndexOfImage(this.props.selectedImage);
    const images = this.props.images;
    if (!images) return;

    if (index === 0) {
      index = images.length;
    }
    index--;

    this.props.onSelectImage(images[index]);
    this.setState({
      littleImagesBaseOffsetX: 0,
    });
  };

  onClickExitButton = () => {
    this.props.onClose && this.props.onClose();
  };

  onClickImage = (image, index) => {
    this.props.onSelectImage(image);
    this.setState({
      littleImagesBaseOffsetX: 0,
    });
  };

  onMove = (offset) => {
    this.setState({
      imageOffset: offset,
      disableTransition: true,
    })
  };

  onMoveLittileImages = (offset) => {
    this.setState({
      littleImagesOffset: offset,
      disableTransition: true,
    })
  }

  onMoveEnd = (offset) => {
    this.setState({
      imageOffset: Movable.DefaultValues(),
      disableTransition: false,
    });

    const windowWidth = window.innerWidth;
    const changeWidthValue = windowWidth / 5;

    if (offset.dx > changeWidthValue) {
      this.onPrev();
    } else if (offset.dx < -changeWidthValue) {
      this.onNext();
    }
  }

  onMoveEndLittileImages = (offset) => {
    this.setState({
      littleImagesOffset: Movable.DefaultValues(),
      littleImagesBaseOffsetX: this.state.littleImagesBaseOffsetX + offset.dx,
      disableTransition: false,
    });
  }

  setAsLoaded3ImagesAroundThis = (image) => {
    const images = this.props.images;
    const indexes = [image.id];

    indexes[0] === images.length - 1 ? indexes.push(0) : indexes.push(image.id + 1);
    indexes[0] === 0 ? indexes.push(images.length - 1) : indexes.push(image.id - 1);

    for (let index of indexes) {
      images[index].loaded = true;
    }
  };

  componentDidMount() {
    window.addEventListener('keyup', this.onKeyUp);
    Utils.disableScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyUp);
    Utils.enableScroll();
  }

  render() {
    this.setAsLoaded3ImagesAroundThis(this.props.selectedImage);

    const selectedIndex = this.getIndexOfImage(this.props.selectedImage);
    const move = selectedIndex * 100;

    const imageHandlerStyle = {
      transform: `translateX(calc(-${move}% + ${this.state.imageOffset.dx}px))`,
    }
    const littleImageHandlerStyle = {
      transform: `translateX(calc(-${move}% + ${this.state.littleImagesBaseOffsetX}px + ${this.state.littleImagesOffset.dx}px))`,
    }

    const littleImageSelectedStyle = {
      transform: `translate(calc(-50% + ${this.state.littleImagesBaseOffsetX}px + ${this.state.littleImagesOffset.dx}px), -50%)`,
    }

    if (this.state.disableTransition) {
      imageHandlerStyle.transition = 'none';
      littleImageHandlerStyle.transition = 'none';
      littleImageSelectedStyle.transition = 'none';
    }

    return (
      <div className={styles.FullGallery}>
        <div className={styles.ImageContainer} {...this.movableEvents}>
          <div className={styles.ImageHandler} style={imageHandlerStyle}>
            {this.props.images.map(image => {
              return (
                <Image key={image.id} className={styles.Image} src={image.loaded ? image.img : ''}/>
              );
            })}
          </div>

          <ArrowLeft className={styles.ArrowLeft} onClick={this.onPrev.bind(this)}/>
          <ArrowRight className={styles.ArrowRight} onClick={this.onNext.bind(this)}/>
        </div>

        <ExitButton className={styles.ExitButton} onClick={this.onClickExitButton}/>

        <div className={styles.LittleImageContainer} {...this.movableLittleImagesEvents}>
          <div className={styles.LittleImageHandler} style={littleImageHandlerStyle}>
            {this.props.images.map((image, index) => {
              return (
                <Image key={image.id} className={styles.LittleImage} src={image.imgThumb}
                       onClick={() => this.onClickImage(image, index)}/>
                );
              })}
          </div>
          <div className={styles.LittleImageSelected} style={littleImageSelectedStyle}/>
        </div>
      </div>
    );
  }
}

export default FullGallery;
